export * from './ticket-system.component';
export * from './ticket-system-new.component';
export * from './ticket-system-edit.component';
